
export default "/assets/arrow-up-micro.c58580f7.svg"